.trigger {
  box-sizing: border-box;
  height: var(--button-height);
  width: 160px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: 0 var(--space-4);
  border: 1px solid var(--color-focus-border);
  border-radius: var(--button-radius);
  background: var(--color-surface);
  color: var(--color-primary);
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  white-space: nowrap;
}

.trigger:hover {
  background: var(--color-surface-subtle);
}

.trigger:focus-visible {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px var(--color-focus-ring);
}

.triggerIcon {
  width: 1.125rem;
  height: 1.125rem;
  flex: 0 0 auto;
}

.chevron {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 150ms ease;
}

.chevronOpen {
  transform: rotate(180deg);
}

.popup {
  box-sizing: border-box;
  width: min(260px, calc(100vw - var(--space-8)));
  display: flex;
  flex-direction: column;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-surface);
  box-shadow:
    0 18px 48px var(--color-box-shadow-bold),
    0 4px 12px var(--color-box-shadow-subtle);
  color: var(--color-text-dark);
  overflow: hidden;
  z-index: 50;
}

.header {
  display: flex;
  align-items: center;
  padding: var(--space-5) var(--space-5) var(--space-3);
}

.title {
  margin: 0;
  color: var(--color-text-dark);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
}

.optionList {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding: 0 var(--space-3) var(--space-3);
}

.option {
  box-sizing: border-box;
  width: 100%;
  min-height: 2.75rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: 0 var(--space-3);
  border: 0;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--color-text-dark);
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  text-align: left;
  cursor: pointer;
}

.option:hover {
  background: var(--color-surface-subtle);
}

.option:focus-visible {
  outline: none;
  background: var(--color-primary-subtle);
  box-shadow: inset 0 0 0 2px var(--color-focus-border);
}

.optionSelected {
  background: var(--color-primary-subtle);
  color: var(--color-primary);
  font-weight: var(--font-weight-semibold);
}

.optionSelected:hover {
  background: var(--color-primary-subtle);
}

.optionIcon {
  width: 1.125rem;
  height: 1.125rem;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--color-primary);
}

@media screen and (max-width: 640px) {
  .trigger {
    padding: 0 var(--space-3);
  }

  .popup {
    width: min(240px, calc(100vw - var(--space-6)));
  }
}

@media (prefers-reduced-motion: reduce) {
  .chevron {
    transition: none;
  }
}